<template>
  <div class="tpp-page">
    <zhuomuniao-ops-nav active-path="/pages/tpp/zhuomuniao/orders" :platform-id="platformId" />
    <section class="tpp-panel">
      <div class="tpp-panel__head">
        <div>
          <h2 class="tpp-panel__title">履约订单</h2>
          <p class="tpp-muted">只读 hs_order。不可手工改派单/完成/退款；同步失败可补推 createOrder。</p>
        </div>
        <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="load">刷新</el-button>
      </div>
      <div class="tpp-filter">
        <el-select v-model="filters.communityId" placeholder="全部小区" clearable filterable style="width:180px">
          <el-option v-for="item in communityOptions" :key="item.communityId" :label="item.name" :value="item.communityId" />
        </el-select>
        <el-input v-model.trim="filters.orderId" placeholder="本地订单号" clearable style="width:180px" @keyup.enter.native="search" />
        <el-input v-model.trim="filters.externalOrderId" placeholder="啄木鸟订单号" clearable style="width:160px" @keyup.enter.native="search" />
        <el-select v-model="filters.state" placeholder="履约状态" clearable style="width:140px">
          <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </div>
    </section>
    <section class="tpp-panel">
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="orderId" label="本地单号" min-width="170" />
        <el-table-column prop="externalOrderId" label="对方单号" min-width="130">
          <template slot-scope="scope">{{ scope.row.externalOrderId || '-' }}</template>
        </el-table-column>
        <el-table-column prop="productName" label="服务" min-width="140" />
        <el-table-column label="小区" min-width="120">
          <template slot-scope="scope">{{ scope.row.communityName || scope.row.communityId || '-' }}</template>
        </el-table-column>
        <el-table-column prop="appointmentTime" label="预约时间" width="160" />
        <el-table-column label="预付/实收" width="130">
          <template slot-scope="scope">{{ scope.row.prepayAmount }} / {{ scope.row.receivedAmount || '0.00' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="110" align="center">
          <template slot-scope="scope"><el-tag :type="stateTag(scope.row.state)" size="small">{{ scope.row.stateName || scope.row.state }}</el-tag></template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" />
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="goZhuomuniao('/pages/tpp/zhuomuniao/order-detail', { orderId: scope.row.orderId })">详情</el-button>
            <el-button v-if="canRetry(scope.row.state)" type="text" @click="retry(scope.row)">补推</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="tpp-pagination" :current-page.sync="page.current" :page-size="page.size" :total="page.total"
        layout="total, prev, pager, next" @current-change="load" />
    </section>
  </div>
</template>
<script>
import ZhuomuniaoOpsNav from './zhuomuniaoNav.vue'
import { zhuomuniaoOpsMixin } from './zhuomuniaoOpsMixin'
import { listOrders, retrySyncOrder } from '@/api/life/homeServiceApi'
import { listAdminCommunitys } from '@/api/owner/adminOwnerApi'
import { zmnTotal } from '@/api/tpp/zhuomuniaoOpsApi'
import '../tpp.scss'
const STATE_OPTIONS = [
  { value: 'UNPAID', label: '待支付' }, { value: 'PAID_LOCAL', label: '本地已付' }, { value: 'SYNCING', label: '同步中' },
  { value: 'WAIT_ACCEPT', label: '等待安排' }, { value: 'DISPATCHED', label: '已派单' }, { value: 'ACCEPTED', label: '已接单' },
  { value: 'VISITING', label: '上门中' }, { value: 'COMPLETED', label: '已完成' }, { value: 'CANCELLED', label: '已取消' },
  { value: 'REFUNDING', label: '退款中' }, { value: 'REFUNDED', label: '已退款' }, { value: 'SYNC_FAILED', label: '同步失败' }
]
export default {
  name: 'ZhuomuniaoOrders',
  components: { ZhuomuniaoOpsNav },
  mixins: [zhuomuniaoOpsMixin],
  data() {
    return {
      loading: false, rows: [], communityOptions: [], stateOptions: STATE_OPTIONS,
      filters: { communityId: '', orderId: '', externalOrderId: '', state: '' },
      page: { current: 1, size: 10, total: 0 }
    }
  },
  async created() {
    this.filters.state = String(this.$route.query.state || '')
    if (await this.ensureZhuomuniaoPlatform()) {
      this.loadCommunities()
      this.load()
    }
  },
  methods: {
    canRetry(state) { return ['PAID_LOCAL', 'SYNCING', 'SYNC_FAILED'].includes(state) },
    stateTag(state) {
      return { UNPAID: 'info', PAID_LOCAL: 'warning', SYNCING: 'warning', VISITING: 'warning', COMPLETED: 'success', CANCELLED: 'info', REFUNDING: 'warning', REFUNDED: 'success', SYNC_FAILED: 'danger' }[state] || ''
    },
    search() { this.page.current = 1; this.load() },
    async loadCommunities() {
      try { const res = await listAdminCommunitys({ page: 1, row: 500 }); this.communityOptions = res.data || [] }
      catch (e) { this.communityOptions = [] }
    },
    async load() {
      this.loading = true
      try {
        const res = await listOrders({ ...this.filters, page: this.page.current, row: this.page.size })
        this.rows = res.data || []
        this.page.total = zmnTotal(res)
      } catch (e) { this.rows = []; this.page.total = 0; this.$message.error(e.message || '订单加载失败') }
      finally { this.loading = false }
    },
    async retry(row) {
      try {
        await this.$confirm(`确认补推同步订单「${row.orderId}」？未知结果不换号重建。`, '补推同步', { type: 'warning' })
        const res = await retrySyncOrder({ orderId: row.orderId })
        const data = res.data || res
        this.$message.success(`补推完成：${data.stateName || data.state || '已提交'}`)
        this.load()
      } catch (e) { if (e !== 'cancel') this.$message.error(e.message || '补推失败') }
    }
  }
}
</script>
